import React from "react";
import './visual-story.m.css';
import {altTagOfHeroImages, isExternalStory} from "../../utils";
import { Link, ResponsiveHeroImage } from "@quintype/components";
import {StoryHeaderCard} from "../story-page-components/story-header-card";
import {AmpIcon} from "../basic/amp-icon";
import {breakpoint} from "../../../utils/breakpoint";

export const VisualStory = ({story = {}, config = {}}) => {
  const imageElement = breakpoint('tablet') ?
    <ResponsiveHeroImage story={story}
                         aspectRatio={[16,9]}
                         alt={altTagOfHeroImages(story)}
                         defaultWidth={480} widths={[250,480,640]} sizes="(max-width: 500px) 98%, (max-width: 768px) 48%, 98%"
                         imgParams={{auto:['format', 'compress'], fit:'max'}} /> :
    <ResponsiveHeroImage story={story}
                         aspectRatio={[8,3]}
                         alt={altTagOfHeroImages(story)}
                         defaultWidth={480} widths={[250,480,640,960,1200]} sizes="(max-width: 500px) 98%"
                         imgParams={{auto:['format', 'compress'], fit:'max'}} />;

  return <article className="blank-story">
    {
      story["hero-image-s3-key"] ?
        <figure className="blank-story-hero-image qt-responsive-image">
          {imageElement}
        </figure>:
        <div className="blank-story-hero-image__fallback-placeholder">
        </div>
    }
    <div className="blank-story--wrapper">
      <div className="blank-story--content" styleName="container">
        <StoryHeaderCard story={story} config={config}/>
        <div styleName="cta">
            <Link href={`/${story.slug}`} externalLink={isExternalStory(story)}>
              <div styleName="ampIcon"><AmpIcon /></div>
              View story
            </Link>
          </div>
      </div>
    </div>
  </article>
};

